import { preview } from '@/components/form/preview'
import { useTexts } from './hooks/useTexts'
import { BulkViewData } from '../../hooks/useBulkViewData/types'

type Props = {
  bulkData: BulkViewData
}

export function Phone(props: Props) {
  const {
    bulkData: { phone },
  } = props

  const texts = useTexts()

  return (
    <preview.Field label={texts.contactInformation.phone.label}>
      {phone === 'mixed' ? (
        <preview.MixValue />
      ) : phone.length === 0 ? (
        <preview.NullValue />
      ) : (
        phone
      )}
    </preview.Field>
  )
}
